import React, { Component, Fragment } from "react";
import TopNavigation from "../../Components/Common/TopNavigation";
import VideoDetails from "../../Components/VideoDetails/VideoDetails";
import VideoComments from "../../Components/VideoDetails/VideoComments";
import Footer from "../../Components/Common/Footer";

class VideoDetailsPage extends Component {
  componentDidMount() {
    window.scroll(0, 0);
  }

  render() {
    return (
      <Fragment>
        <TopNavigation />
        <div className="responsive-padding-top">
          <VideoDetails />
          <VideoComments />
        </div>
        <Footer />
      </Fragment>
    );
  }
}

export default VideoDetailsPage;
